import React from "react";
import { NavLink } from "react-router-dom";
import { dispatchCustomEvent } from "../../helpers/Utilities";
import Svg from "../Utilities/Svg";

const menuItems = [
  { name: "Bingo Caller", key: "bingo-caller", link: "/", icon: "gamepad" },
  { name: "Play Along", key: "play-along", link: "/play", icon: "play" },
  { name: "Get Bingo Cards", key: "get-bingo-cards", link: "/generator", icon: "download" },
  { name: "Pattern List", key: "pattern-list", link: "/patterns", icon: "grid" },
  { name: "Submit a Pattern", key: "submit-a-pattern", link: "/submitpattern", icon: "plus" },
  { name: "About", key: "about", link: "/about", icon: "info", separator: true },
  { name: "Instructions / How to Play", key: "instructions", link: "/help", icon: "question" },
  { name: "Settings Guide", key: "guide", link: "/guide", icon: "book" },
  { name: "Layouts Gallery", key: "layouts", link: "/layouts", icon: "layout" },
  { name: "Frequently Asked Questions", key: "faq", link: "/faq", icon: "comments-question-check" },
  { name: "Donate", key: "donate", link: "/donate", icon: "give" },
  { name: "Let's Play Bingo Pro", key: "pro", link: "http://letsplaybingo.pro", icon: "pro", external: true, separator: true },
  { name: "Let's Play Bingo Store", key: "store", link: "http://letsplaybingo.store", icon: "shop", external: true },
  { name: "Release Notes", key: "release-notes", link: "/releases", icon: "notes-sticky" },
  { name: "Fairness & Transparency", key: "transparency", link: "/transparency", icon: "transparent" },
  { name: "Contact", key: "contact", link: "/contact", icon: "envelope" },
];

/**
 * Menu class
 * Renders the navigational menu that's used across the site
 * Maintains a state for indicating if the menu is open or not
 * Listens for the settings panel to be opened, if it is, it closes this menu
 */
class Menu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
    };
  }

  handleSettingsPanelOpen = () => {
    this.setState({ menuOpen: false });
  };

  componentDidMount() {
    document.addEventListener("settingspanel-open", this.handleSettingsPanelOpen);
  }

  componentWillUnmount() {
    document.removeEventListener("settingspanel-open", this.handleSettingsPanelOpen);
  }

  toggleMenu = () => {
    this.setState({ menuOpen: !this.state.menuOpen });
    dispatchCustomEvent("menu-open", !this.state.menuOpen);
  };

  getMenuDisplay() {
    if (this.state.menuOpen) {
      return (
        <div className="menu-dropdown">
          <ul className="menu">
            {menuItems.map((item) => {
              if (item.external) {
                return (
                  <li key={item.key} className={item.separator ? "separator" : ""}>
                    <a href={item.link} target="_blank" rel="noreferrer" onClick={this.toggleMenu}>
                      <Svg icon={item.icon} size="md" />
                      {item.name}
                    </a>
                  </li>
                );
              } else {
                return (
                  <li key={item.key} className={item.separator ? "separator" : ""}>
                    <NavLink to={item.link} className={({ isActive }) => (isActive ? "active" : "")} onClick={this.toggleMenu}>
                      <Svg icon={item.icon} size="md" />
                      {item.name}
                    </NavLink>
                  </li>
                );
              }
            })}
          </ul>
        </div>
      );
    } else {
      return null;
    }
  }

  render() {
    return (
      <div>
        <div className={this.state.menuOpen ? "backdrop" : "backdrop hide"} onClick={this.toggleMenu}></div>
        <div className="relative">
          <div className={this.state.menuOpen ? "menu-container open" : "menu-container closed"}>
            <button aria-label="Menu" className="icon-button" title="Menu" onClick={this.toggleMenu}>
              <Svg icon={this.state.menuOpen ? "xmark" : "bars"} />
            </button>
            {this.getMenuDisplay()}
          </div>
        </div>
      </div>
    );
  }
}

export default Menu;
